// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  z-index: 2;
}

.about-container {
  max-width: 1000px;
  margin: 0 auto;
}

.about-header {
  text-align: center;
  margin-bottom: 40px;
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.about-title {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.title-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

.about-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.love-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 50px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
  display: flex;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);
}

.stat-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
}

.stat-info {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: block;
}

.stat-text {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.8;
}

.couple-profiles {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 30px;
  align-items: center;
  margin-bottom: 60px;
}

.profile-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  padding: 30px;
  border: 2px solid;
  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);
  text-align: center;
  color: white;
  transition: all 0.3s ease;
}

.profile-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(255, 105, 180, 0.3);
}

.profile-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  margin: 0 auto 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.profile-name {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.profile-age {
  font-size: 1rem;
  opacity: 0.8;
  margin-bottom: 20px;
}

.profile-details {
  text-align: left;
  margin-bottom: 20px;
}

.detail-item {
  margin-bottom: 10px;
  line-height: 1.5;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.detail-item strong {
  color: rgba(255, 255, 255, 0.9);
}

.profile-quote {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 15px;
  border-left: 4px solid;
  border-left-color: inherit;
  position: relative;
}

.quote-icon {
  position: absolute;
  top: -5px;
  left: 10px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.2rem;
}

.profile-quote p {
  font-style: italic;
  line-height: 1.4;
  margin: 0;
  padding-left: 20px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.love-symbol {
  display: flex;
  justify-content: center;
  align-items: center;
}

.heart-animation {
  font-size: 4rem;
  filter: drop-shadow(0 4px 8px rgba(255, 105, 180, 0.5));
}

.timeline-section {
  margin-bottom: 50px;
}

.timeline-title {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  margin-bottom: 40px;
  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);
}

.timeline {
  position: relative;
  padding: 20px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #ff69b4, #ff1493, #dc143c);
  transform: translateX(-50%);
}

.timeline-item {
  display: flex;
  margin-bottom: 40px;
  position: relative;
}

.timeline-item:nth-child(even) {
  flex-direction: row-reverse;
}

.timeline-item:nth-child(even) .timeline-content {
  margin-left: 0;
  margin-right: 30px;
  text-align: right;
}

.timeline-item:nth-child(odd) .timeline-content {
  margin-left: 30px;
  margin-right: 0;
  text-align: left;
}

.timeline-date {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  color: white;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);
  z-index: 10;
}

.timeline-content {
  flex: 1 1;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
  color: white;
  transition: all 0.3s ease;
}

.timeline-content:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);
}

.timeline-event {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 10px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.timeline-description {
  line-height: 1.5;
  opacity: 0.9;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.about-footer {
  text-align: center;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);
}

.footer-message {
  color: white;
}

.footer-message h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 20px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.footer-message p {
  font-size: 1.1rem;
  line-height: 1.6;
  opacity: 0.9;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.heart-icon {
  color: #ff69b4;
  font-size: 1.5rem;
  animation: heartbeat 2s ease-in-out infinite;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .about-title {
    font-size: 2rem;
  }
  
  .love-stats {
    grid-template-columns: 1fr;
  }
  
  .couple-profiles {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .love-symbol {
    order: -1;
  }
  
  .heart-animation {
    font-size: 3rem;
  }
  
  .timeline::before {
    left: 30px;
  }
  
  .timeline-item {
    flex-direction: column !important;
  }
  
  .timeline-item:nth-child(even) .timeline-content,
  .timeline-item:nth-child(odd) .timeline-content {
    margin-left: 50px;
    margin-right: 0;
    text-align: left;
  }
  
  .timeline-date {
    left: 30px;
    transform: translateX(-50%);
  }
  
  .timeline-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  .about-page {
    padding: 10px;
  }
  
  .back-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 20px;
    display: inline-flex;
  }
  
  .about-title {
    font-size: 1.8rem;
  }
  
  .stat-card {
    padding: 20px;
    gap: 15px;
  }
  
  .stat-icon {
    width: 50px;
    height: 50px;
    font-size: 1.2rem;
  }
  
  .profile-card {
    padding: 20px;
  }
  
  .profile-avatar {
    width: 60px;
    height: 60px;
    font-size: 2rem;
  }
  
  .profile-name {
    font-size: 1.5rem;
  }
  
  .timeline-content {
    padding: 20px;
  }
  
  .about-footer {
    padding: 30px 20px;
  }
  
  .footer-message h3 {
    font-size: 1.3rem;
  }
  
  .footer-message p {
    font-size: 1rem;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/AboutPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,oDAAoD;EACpD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,+CAA+C;EAC/C,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA,UAAU;AACV;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".about-page {\n  min-height: 100vh;\n  padding: 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.about-container {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.about-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.about-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.title-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n.about-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1.1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.love-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 25px;\n  margin-bottom: 50px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  transition: all 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.5rem;\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n}\n\n.stat-info {\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  display: block;\n}\n\n.stat-text {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.couple-profiles {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 30px;\n  align-items: center;\n  margin-bottom: 60px;\n}\n\n.profile-card {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 25px;\n  padding: 30px;\n  border: 2px solid;\n  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);\n  text-align: center;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.profile-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 15px 40px rgba(255, 105, 180, 0.3);\n}\n\n.profile-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  margin: 0 auto 20px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.profile-name {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.profile-age {\n  font-size: 1rem;\n  opacity: 0.8;\n  margin-bottom: 20px;\n}\n\n.profile-details {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.detail-item {\n  margin-bottom: 10px;\n  line-height: 1.5;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.detail-item strong {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.profile-quote {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 15px;\n  border-left: 4px solid;\n  border-left-color: inherit;\n  position: relative;\n}\n\n.quote-icon {\n  position: absolute;\n  top: -5px;\n  left: 10px;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 1.2rem;\n}\n\n.profile-quote p {\n  font-style: italic;\n  line-height: 1.4;\n  margin: 0;\n  padding-left: 20px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.love-symbol {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.heart-animation {\n  font-size: 4rem;\n  filter: drop-shadow(0 4px 8px rgba(255, 105, 180, 0.5));\n}\n\n.timeline-section {\n  margin-bottom: 50px;\n}\n\n.timeline-title {\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-align: center;\n  margin-bottom: 40px;\n  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);\n}\n\n.timeline {\n  position: relative;\n  padding: 20px 0;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: linear-gradient(to bottom, #ff69b4, #ff1493, #dc143c);\n  transform: translateX(-50%);\n}\n\n.timeline-item {\n  display: flex;\n  margin-bottom: 40px;\n  position: relative;\n}\n\n.timeline-item:nth-child(even) {\n  flex-direction: row-reverse;\n}\n\n.timeline-item:nth-child(even) .timeline-content {\n  margin-left: 0;\n  margin-right: 30px;\n  text-align: right;\n}\n\n.timeline-item:nth-child(odd) .timeline-content {\n  margin-left: 30px;\n  margin-right: 0;\n  text-align: left;\n}\n\n.timeline-date {\n  position: absolute;\n  left: 50%;\n  top: 10px;\n  transform: translateX(-50%);\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  color: white;\n  padding: 8px 15px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(255, 105, 180, 0.4);\n  z-index: 10;\n}\n\n.timeline-content {\n  flex: 1;\n  max-width: 400px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.timeline-content:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 35px rgba(255, 105, 180, 0.3);\n}\n\n.timeline-event {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.timeline-description {\n  line-height: 1.5;\n  opacity: 0.9;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.about-footer {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 25px;\n  padding: 40px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 10px 30px rgba(255, 105, 180, 0.2);\n}\n\n.footer-message {\n  color: white;\n}\n\n.footer-message h3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 20px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.footer-message p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  opacity: 0.9;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.heart-icon {\n  color: #ff69b4;\n  font-size: 1.5rem;\n  animation: heartbeat 2s ease-in-out infinite;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n}\n\n@keyframes heartbeat {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .about-title {\n    font-size: 2rem;\n  }\n  \n  .love-stats {\n    grid-template-columns: 1fr;\n  }\n  \n  .couple-profiles {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .love-symbol {\n    order: -1;\n  }\n  \n  .heart-animation {\n    font-size: 3rem;\n  }\n  \n  .timeline::before {\n    left: 30px;\n  }\n  \n  .timeline-item {\n    flex-direction: column !important;\n  }\n  \n  .timeline-item:nth-child(even) .timeline-content,\n  .timeline-item:nth-child(odd) .timeline-content {\n    margin-left: 50px;\n    margin-right: 0;\n    text-align: left;\n  }\n  \n  .timeline-date {\n    left: 30px;\n    transform: translateX(-50%);\n  }\n  \n  .timeline-title {\n    font-size: 1.8rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-page {\n    padding: 10px;\n  }\n  \n  .back-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 20px;\n    display: inline-flex;\n  }\n  \n  .about-title {\n    font-size: 1.8rem;\n  }\n  \n  .stat-card {\n    padding: 20px;\n    gap: 15px;\n  }\n  \n  .stat-icon {\n    width: 50px;\n    height: 50px;\n    font-size: 1.2rem;\n  }\n  \n  .profile-card {\n    padding: 20px;\n  }\n  \n  .profile-avatar {\n    width: 60px;\n    height: 60px;\n    font-size: 2rem;\n  }\n  \n  .profile-name {\n    font-size: 1.5rem;\n  }\n  \n  .timeline-content {\n    padding: 20px;\n  }\n  \n  .about-footer {\n    padding: 30px 20px;\n  }\n  \n  .footer-message h3 {\n    font-size: 1.3rem;\n  }\n  \n  .footer-message p {\n    font-size: 1rem;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
